import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';
// eslint-disable-next-line import/no-webpack-loader-syntax
import workerCode from '!!raw-loader!pdfjs-dist/legacy/build/pdf.worker.mjs';

// Create a Blob from the raw source
const blob = new Blob([workerCode], { type: 'application/javascript' });
const workerUrl = URL.createObjectURL(blob);

// Assign the worker URL to PDF.js
pdfjsLib.GlobalWorkerOptions.workerSrc = workerUrl;

export default pdfjsLib;
